import axios from 'axios';
import ChildTemplate from '../_/ChildTemplate';

export default class extends ChildTemplate {
  #map = new Map();

  get authentication() {
    return this.parent.authentication;
  }

  get(url, parameters = {}) {
    return this.other({
      ...parameters,
      method: 'GET',
      url,
    });
  }

  post(url, data, parameters = {}) {
    return this.other({
      ...parameters,
      method: 'POST',
      url,
      data,
    });
  }

  other(parameters = {}) {
    return new Promise((resolve, reject) => {
      axios(parameters)
        .then(({ data }) => {
          if (data?.ResultQueryInfo?.HasError || data?.ResultQueryInfo?.UserMessages) {
            reject(data.ResultQueryInfo.UserMessages);
          }
          resolve(data);
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
            return;
          }
          if (error?.response?.status === 401) {
            this.authentication
              .open()
              .then(() => {
                this.other(parameters).then(resolve, reject);
              });
          }
          reject('Сервис временно не доступен');
        });
    });
  }

  store(key) {
    const other = (parameters) => {
      if (!this.#map.get(key)) {
        this.#map.set(key, this.other(parameters));
      }
      return this.#map.get(key);
    };
    return {
      get(url, parameters) {
        return other({
          ...parameters,
          method: 'GET',
          url,
        });
      },
      post(url, data, parameters) {
        return other({
          ...parameters,
          method: 'GET',
          data,
          url,
        });
      },
      other,
    };
  }

  clean(key, flag) {
    switch (flag) {
      case 'all':
        this.#map = new Map();
        break;
      case 'key':
        this.#map.delete(key);
        break;
      case 'group':
        this.#map.forEach((_, i) => {
          if (i.toString().indexOf(key) === 0) {
            this.#map.delete(i);
          }
        });
        break;
      default:
        if (key) {
          this.#map.delete(key);
        } else {
          this.#map = new Map();
        }
        break;
    }
  }
}
